import { useMemo } from "react";
import { NavLink } from "react-router-dom";
import { cn } from "@/lib/cn";
import { WORKSHOP_PAGES } from "./workshop-routes";
import { useWorkshopSearch } from "./workshop-search-context";

export function WorkshopIndex() {
  const search = useWorkshopSearch();

  const filtered = useMemo(() => {
    if (!search.trim()) return WORKSHOP_PAGES;
    const q = search.toLowerCase();
    return WORKSHOP_PAGES.filter(
      (p) =>
        p.label.toLowerCase().includes(q) ||
        p.path.toLowerCase().includes(q) ||
        p.category.toLowerCase().includes(q),
    );
  }, [search]);

  return (
    <div className="mx-auto max-w-lg px-6 py-10" data-testid="workshop-index">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-white">Workshop</h1>
        <p className="mt-2 text-sm text-white/50">
          UI development sandbox for Denker Dolcetto. Build pages and components
          with dummy data — no backend required.
        </p>

        {filtered.length > 0 ? (
          <div className="mt-8 grid gap-2">
            {filtered.map((page) => (
              <NavLink
                key={page.path}
                to={`/workshop/${page.path}`}
                className={cn(
                  "rounded-lg border border-white/[0.06] bg-white/[0.02] px-4 py-3",
                  "text-left text-sm text-white/70 transition-colors",
                  "hover:border-accent/30 hover:bg-accent/5 hover:text-white"
                )}
                data-testid={`workshop-index-${page.path}`}
              >
                <span className="font-medium">{page.label}</span>
                <span className="ml-2 text-xs text-white/30">{page.category}</span>
              </NavLink>
            ))}
          </div>
        ) : search.trim() ? (
          <div className="mt-8 rounded-lg border border-dashed border-white/10 px-6 py-8">
            <p className="text-sm text-white/30">
              No pages match &ldquo;{search}&rdquo;
            </p>
          </div>
        ) : (
          <div className="mt-8 rounded-lg border border-dashed border-white/10 px-6 py-8">
            <p className="text-sm text-white/30">
              No workshop pages yet. Create a page in the workshop directory
              and register it in{" "}
              <code className="rounded bg-white/5 px-1.5 py-0.5 text-xs text-accent">
                workshop-routes.tsx
              </code>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
